/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { DeleteFamilyMemberPathParameters } from 'api/actions/delete-family-member/delete-family-member-path-parameters';
import { DeleteFamilyMemberResponse } from 'api/actions/delete-family-member/delete-family-member-response';

type DeleteFamilyMemberQueryParameters = Record<string, any>;

/**
 * The path of the DeleteFamilyMember action.
 */
export const deleteFamilyMemberActionPath = new SweetPath<keyof DeleteFamilyMemberPathParameters>(
  '/user/family/members/{userId}/delete',
  { path: '{param}' }
);

/**
 * Creates a contextualized DeleteFamilyMember actions.
 */
export default function createDeleteFamilyMemberAction(axios: AxiosInstance) {
  return function deleteFamilyMemberAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: DeleteFamilyMemberPathParameters;
    query?: DeleteFamilyMemberQueryParameters;
  }) {
    const path = deleteFamilyMemberActionPath.insert(parameters);

    return axios.post<DeleteFamilyMemberResponse, DeleteFamilyMemberResponse>(path, { params: query, headers });
  };
}
